import moment from 'moment'

export const data = () => ({
  isDebug: true,
  loading: false,
  selectedOwnerPaymentMethod: null,
  ownerPaymentMethodID: null,
  ownerID: null,
  scheduledOwnerPaymentMethodID: null,
  paymentMethods: [],
  paymentsEnabled: true,
  formatDateFn: function(value) {
    return value != null ? moment(value, 'YYYY/MM/DD HH:mm:ss').format('MM-DD-YYYY') : ''
  },
  ownerAdditionalScheduledPayments: [],
  chargeTypeList: [],
  form: {
    amount: [],
    amountId: []
  },

  formatter: new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    numeralDecimalScale: 2
  }),

  masks: {
    creditCard: {
      creditCard: true
    },
    numeral: {
      numeral: true,
      numeralThousandsGroupStyle: 'thousand',
      prefix: '$'
    },
    custom: {
      delimiters: [',', '.'],
      blocks: [3, 3, 2],
      numericOnly: true
    }
  }
})
